import { render, staticRenderFns } from "./BaseButtonText.vue?vue&type=template&id=bdf2306a"
import script from "./BaseButtonText.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButtonText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports